import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useUserSetting } from '../../../../../hooks/use-user-setting';
import { saveUserSetting } from '../../../../../store/user/user.actions';
import { UserSettings } from '../../../../../enums/user-settings/user-settings';

export enum CustomsViewMode {
  Tab = 'tab',
  List = 'list',
}

type UseCustomsViewModeReturn = {
  viewMode: CustomsViewMode;
  handleChangeViewMode: (viewMode: string) => void;
};

export const useCustomsViewMode = (): UseCustomsViewModeReturn => {
  const dispatch = useDispatch();
  const savedViewMode = useUserSetting(UserSettings.customsFormViewMode.settingName);

  const [viewMode, setViewMode] = useState(savedViewMode ?? CustomsViewMode.List);

  const handleChangeViewMode = useCallback(
    (newViewMode: string) => {
      setViewMode(newViewMode);
      dispatch(
        saveUserSetting({
          settingName: UserSettings.customsFormViewMode.settingName,
          settingValue: newViewMode,
          excludeV3prefix: true,
        }),
      );
    },
    [dispatch],
  );

  return { viewMode, handleChangeViewMode };
};
